/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AvailablePlansResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAvailableSubscriptions: build.query<AvailablePlansResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/billing/subscription/plans` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getAvailableSubscriptionsApi };
export const { useGetAvailableSubscriptionsQuery, useLazyGetAvailableSubscriptionsQuery } = injectedRtkApi;
